import type { Item } from '../../domain';
import type { SystemBuilder } from '../SystemBuilder';
import { RolloBuilder } from './RolloBuilder';

/** Вернуть билдер для типа системы. Пока реализован rollo (MVP). */
export function getBuilder(model: Item['model']): SystemBuilder<Item> {
  switch (model) {
    case 'rollo':
      return new RolloBuilder();
    default:
      throw new Error(`Билдер для системы "${model}" ещё не реализован`);
  }
}

export { BaseSystemBuilder } from './BaseSystemBuilder';
export { RolloBuilder };
